// src/services/products.api.js
const API_URL =
  process.env.REACT_APP_API_URL || "http://localhost:5000/api";

/**
 * Get all products (public)
 * Optional filters:
 *  - sale=true
 *  - bestseller=true
 *  - new=true
 */
export async function getAllProducts(filters = {}) {
  const qs = new URLSearchParams();

  Object.entries(filters).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    qs.set(k, String(v));
  });

  const res = await fetch(`${API_URL}/products${qs.toString() ? `?${qs}` : ""}`);
  const data = await res.json();

  if (!res.ok) {
    throw new Error(data?.message || "Failed to load products");
  }

  return data;
}

/**
 * Get product details by SEO slug (public)
 * Backend route: GET /api/products/:slug
 */
export async function getProductBySlug(slug) {
  if (!slug) throw new Error("Missing product slug");

  const res = await fetch(`${API_URL}/products/${encodeURIComponent(slug)}`);
  const data = await res.json();

  if (!res.ok) {
    throw new Error(data?.message || "Failed to load product");
  }

  return data;
}

export async function getProductReviewsBySlug(slug) {
  if (!slug) throw new Error("Missing product slug");

  const res = await fetch(
    `${API_URL}/products/${encodeURIComponent(slug)}/reviews`
  );

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data?.message || "Failed to load product reviews");
  }

  return data;
}
